import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateCashFlow } from "../../../../store/modules/financials/actions";
import FinancingHelper from "../../../../helpers/FinancingHelper";
import { primary } from "../../../../assets/colorPallet";
import ItemDiv from "./ItemDiv";
import TotalDiv from "./TotalDiv";

function YearlyDashboard({
  currentCompanyCashFlow,
  dateOrder,
  dispatchGenerateCashFlow,
}) {
  // Mounted
  useEffect(() => {
    handleGenerateCashFlow();
  }, []);

  // Methods
  const handleGenerateCashFlow = async () => {
    await dispatchGenerateCashFlow({ dateOrder });
  };

  return (
    <div className="pb-10">
      <div className="flex items-center w-full mt-10">
        <div
          style={{ backgroundColor: primary }}
          className="absolute left-0 w-full h-12 bg-gradient-to-r from-transparent z-10 pointer-events-none"
        ></div>
        <div className="z-20" style={{ minWidth: "40em" }}></div>
        {currentCompanyCashFlow?.yearsFormatted?.map((date) => (
          <div className="z-20 w-40 font-semibold" style={{ minWidth: "10em" }}>
            <label className="text-white">{date}</label>
          </div>
        ))}
      </div>

      <div className="flex items-center pt-4 mt-5">
        <div className="absolute left-0 w-full h-10 bg-gradient-to-r from-transparent bg-neutral-100 z-10"></div>
        <label className="z-20 font-semibold">Cash from Operations</label>
      </div>
      <div className="items-center pt-4">
        {currentCompanyCashFlow?.yearlyCashFromOperationsArray?.map(
          (item, index) => <ItemDiv item={item} key={index} />
        )}
        <TotalDiv totalArray={currentCompanyCashFlow?.yearlyTotalCashFromOperations} name="Operations" />
      </div>

      <div className="flex items-center pt-4 mt-5">
        <div className="absolute left-0 w-full h-10 bg-gradient-to-r from-transparent bg-neutral-100 z-10"></div>
        <label className="z-20 font-semibold">Cash from Investing</label>
      </div>
      <div className="items-center pt-4">
        {currentCompanyCashFlow?.yearlyCashFromInvestingArray?.map(
          (item, index) => <ItemDiv item={item} key={index} />
        )}
        <TotalDiv totalArray={currentCompanyCashFlow?.yearlyTotalCashFromInvesting} name="Investing" />
      </div>

      <div className="flex items-center pt-4 mt-5">
        <div className="absolute left-0 w-full h-10 bg-gradient-to-r from-transparent bg-neutral-100 z-10"></div>
        <label className="z-20 font-semibold">Cash from Financing</label>
      </div>
      <div className="items-center pt-4">
        {currentCompanyCashFlow?.yearlyCashFromFinancingArray?.map(
          (item, index) => <ItemDiv item={item} key={index} />
        )}
        <TotalDiv totalArray={currentCompanyCashFlow?.yearlyTotalCashFromFinancing} name="Financing" />
      </div>

      <div className="flex items-center mt-2">
        <div
          className="whitespace-nowrap flex items-center py-4"
          style={{ minWidth: "40em" }}
        >
          <label>Opening Cash Balance</label>
        </div>
        <div className="flex py-4">
          {currentCompanyCashFlow?.yearlyOpeningCashBalance?.map((obj) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className={obj?.disabled ? "disabled" : ""}>
                {FinancingHelper.bracketFormatter(obj?.value)}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center mt-2">
        <div
          className="whitespace-nowrap flex items-center py-4"
          style={{ minWidth: "40em" }}
        >
          <label>Net Change in Cash</label>
        </div>
        <div className="flex py-4">
          {currentCompanyCashFlow?.yearlyNetChangeInCash?.map((obj) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label className={obj?.disabled ? "disabled" : ""}>
                {FinancingHelper.bracketFormatter(obj?.value)}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center mt-2">
        <div
          className="whitespace-nowrap flex items-center border-t py-4"
          style={{ minWidth: "40em" }}
        >
          <label className="font-semibold">Closing Cash Balance</label>
        </div>
        <div className="flex border-t py-4">
          {currentCompanyCashFlow?.yearlyClosingCashBalance?.map((obj) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label
                className={
                  obj?.disabled ? "disabled font-semibold" : "font-semibold"
                }
              >
                {FinancingHelper.bracketFormatter(obj?.value)}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyCashFlow: state.financials.currentCompanyCashFlow,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateCashFlow({ dateOrder }) {
    await dispatch(generateCashFlow({ dateOrder }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(YearlyDashboard);
